<template>
  <v-container class="support-request px-6">
    <v-form ref="supportForm" :value="supportFormValid">
      <h1>Ajuda</h1>
      <p>Envie uma mensagem para o time Tradimus Semantix.</p>
    </v-form>
  <v-row>
    <v-col cols="12" md="6" class="pb-0">
    <iframe class="support-request px-6" src="https://tradimus.tomticket.com/formulario?id=EP55619&account=3559616P06012022105059" style="width:100%; min-height:470px; border-width:0px; overflow:auto;"></iframe>
    </v-col>
  </v-row>
    <Footer />
  </v-container>
  
</template>

<script>
import { mapState } from "vuex"
import Footer from "@/components/common/Footer"
export default {
  name: "SupportRequest",
  components: {
    Footer
  },
  data() {
    return {
      formData: {
        Assunto:"",
        OutroAssunto:"",
        Mensagem: ""
      },
      supportFormValid: true,
      items: [
        {
          text: "Autorizador",
          value: "autorizador",
        },
        {
          text: "Faturamento",
          value: "faturamento",
        },
        {
          text: "Recebíveis",
          value: "recebíveis",
        },
        {
          text: "Identificação na operadora",
          value: "identificação na operadora",
        },
        {
          text: "Notificações",
          value: "notificações",
        },
        {
          text: "Documentos",
          value: "documentos",
        },
        {
          text: "Suporte",
          value: "suporte",
        },
        {
          text: "Feedback",
          value: "feedback",
        },
        {
          text: "Outro",
          Value: "Outro",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      userData: (state) => state.userData.userData,
      formRules: (state) => state.formRules,
    }),
  },
  methods: {
    sendForm() {
      if (this.$refs.supportForm.validate()) {
        let {Assunto, OutroAssunto, Mensagem } = this.formData
        Assunto = Assunto == "Outro"? `${OutroAssunto}`:`${Assunto}`
        let obj = {
          query: [{ 
            modulo:"portal",
            acao: "sendemail",
            payload: {
              email: this.userData.Email,
              grupo_economico: this.userData.grupo_economico,
              assunto: Assunto,
              mensagem: Mensagem
            }   
          }],
        };
        this.$store.dispatch("request/doRequest", obj).then((response) => {
           if(!response || response.isAxiosError || response.error) {
            this.$store.commit("hideLoader")
            return
          } 
          let paramModal = { 
            type: 'success',
            title: 'Sucesso',
            message: response.mensagem,
            callback: () => this.$refs.supportForm.reset(),
            btConfirm: { name: 'Ok', show: true },
          }
            this.$store.commit('confirmMessage/showConfirmMessage', paramModal)
          });
      }
    },
  }
};
</script>

<style scoped>
</style>
